import React from 'react'
import { useOutletContext } from 'react-router-dom'

import './styles.scss'

import { useSidebarContext } from '../../contexts/SidebarContext'
import { TopbarLogoutButton } from '../TopbarLogoutButton/TopbarLogoutButton'


export const NavMobile = () => {
  const { openSidebar } = useSidebarContext()
  const { brandLogoUrl, demoName, isSidebarHidden } = useOutletContext<{
    brandLogoUrl: string
    demoName: string
    isSidebarHidden: boolean
  }>()
  return (
    <nav className='accounting-layout__nav accounting-layout__nav--mobile'>
      <div className='accounting-layout__nav__mobile-content'>
        {brandLogoUrl ? (
          <img
            className='accounting-layout__nav__mobile-logo'
            src={brandLogoUrl}
            alt='Client Logo'
          />
        ) : (
          <span className='accounting-layout__nav__mobile-name'>{demoName}</span>
        )}
        <div className='accounting-layout__nav__mobile-actions'>
          {isSidebarHidden && <TopbarLogoutButton />}
          <button
            className='accounting-layout__nav__mobile-menu-button'
            onClick={() => openSidebar(true)}
            aria-label='Open menu'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
            >
              <path
                d='M2.25 9H15.75'
                stroke='currentColor'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M2.25 4.5H15.75'
                stroke='currentColor'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M2.25 13.5H15.75'
                stroke='currentColor'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </button>
        </div>
      </div>
    </nav>
  )
}

